const EmptyViewer = () => null;

export default EmptyViewer;



// WEBPACK FOOTER //
// ./src/components/churchSelector/emptyViewer.js